import { DEFAULT_PAGE, DEFAULT_SORT_BY, DEFAULT_SORT_ORDER } from 'hooks/use-database-list/use-database-list';
import { DEFAULT_PER_PAGE, QueryOptions } from 'sync/query';

type UseDefaultPaginationValuesProps =
  | {
      page?: QueryOptions['page'];
      perPage?: QueryOptions['perPage'];
      sortBy?: QueryOptions['sortBy'];
      sortDirection?: QueryOptions['sortDirection'];
    }
  | {
      entire?: boolean;
    };

export const useDefaultPaginationValues = (props: UseDefaultPaginationValuesProps) => {
  const page = ('page' in props && props.page) || DEFAULT_PAGE;
  const perPage = ('perPage' in props && props.perPage) || DEFAULT_PER_PAGE;
  const entire = ('entire' in props && props.entire) || false;
  const sortBy = ('sortBy' in props && props.sortBy) || DEFAULT_SORT_BY;
  const sortDirection = ('sortDirection' in props && props.sortDirection) || DEFAULT_SORT_ORDER;
  return { page, perPage, entire, sortBy, sortDirection };
};
